// extracted by mini-css-extract-plugin
export default {"capitalized":"SSOFinish_capitalized__Y0fKp","providerBtn":"SSOFinish_providerBtn__RoVmI"};